
export default function CTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-orange-900">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready to Optimize Your Latin America Sourcing?
        </h2>
        <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
          Schedule a free consultation to discuss your procurement challenges and discover how we can reduce your costs
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-orange-700 transition-all hover:-translate-y-1 shadow-lg whitespace-nowrap"
          >
            Get Started Today
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all hover:-translate-y-1 whitespace-nowrap"
          >
            Learn More
          </button>
        </div>
        <div className="mt-12 flex items-center justify-center gap-2 text-gray-400 text-sm">
          <i className="ri-shield-check-line text-lg"></i>
          <span>Trusted by 200+ companies across North America</span>
        </div>
      </div>
    </section>
  );
}
